import React from 'react';
import s from './TextField.module.scss';

interface TextFieldProps {
  label?: string;
  isRequired?: boolean;
  onChange?: (value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  isError?: boolean;
  helperText?: string;
  value?: string;
  placeholder?: string;
  isTextArea?: boolean;
  dataTestId?: string;
  rows?: number;
}

const TextField: React.FC<TextFieldProps> = ({
  label = '',
  isRequired = false,
  onChange = () => {},
  onBlur = () => {},
  isError = false,
  value = '',
  helperText = '',
  placeholder = 'Type here',
  isTextArea = false,
  dataTestId = '',
  rows = 3
}) => {
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (typeof onChange === 'function') {
      onChange(e.target.value);
    }
  };

  return (
    <div className={s.container}>
      <label htmlFor={label} className={s.label}>
        {label}
        {isRequired && <span>*</span>}
      </label>
      {!isTextArea && (
        <input
          data-testid={dataTestId}
          onChange={onInputChange}
          onBlur={onBlur}
          className={s.input}
          type={label.toLowerCase() === 'email' ? 'email' : 'text'}
          value={value}
          name={label}
          placeholder={placeholder}
          required={isRequired}
        />
      )}
      {isTextArea && (
        <textarea
          onChange={onInputChange}
          onBlur={onBlur}
          className={s.input}
          name={label}
          value={value}
          placeholder={placeholder}
          required={isRequired}
          rows={rows}
        />
      )}
      {isError && <p className={s.helperText}>{helperText}</p>}
    </div>
  );
};

export default TextField;
